import { layout } from '../../App.routing'

export const cricketSegment = layout.component({
    type: 'lima',
    props: {
        dataDefinitionArgs: {
            type: 'curation',
            name: 'cricket',
            offset: 0,
            pageSize: 8,
        },
        sectionHeader: {
            heading: 'Cricket',
            headingUrl: '/sport/cricket',
            section: 'sport',
        },
        verticalSpacing: 'xl',
        fixedRatios: ['16:9'],
        finalColumns: 4,
        intermediateColumns: 2,
        stretchSelf: true,
        cardLayout: [
            ['teaserWithBackground'],
            [
                {
                    type: 'landscape',
                    format: 'landscape-xsTeaser-smNoTeaser',
                },
                {
                    type: 'landscape',
                    format: 'landscape-xsTeaser-smNoTeaser',
                },
                {
                    type: 'landscape',
                    format: 'landscape-xsTeaser-smNoTeaser',
                },
            ],
            ['teaserWithBackground'],
            [
                {
                    type: 'landscape',
                    format: 'landscape-xsTeaser-smNoTeaser',
                },
                {
                    type: 'landscape',
                    format: 'landscape-xsTeaser-smNoTeaser',
                },
                {
                    type: 'landscape',
                    format: 'landscape-xsTeaser-smNoTeaser',
                },
            ],
        ],
        cardOrientation: {
            type: 'Landscape-Portrait',
        },
    },
})
